import { Button, Flex, message, Modal, Spin } from "antd"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { spacings } from "themes/variables"
import UploadFile from "./UploadFile"
import { importBulkClient } from "store/clients"

const ImportClientList = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const data = useSelector((state) => state?.clients)
  const [isImportClientModalVisible, setIsImportClientModalVisible] = useState(true)
  const [fileData, setFileData] = useState(null)
  const navigate = useNavigate()

  const handleCloseModal = () => {
    setIsImportClientModalVisible(!isImportClientModalVisible)
    navigate(-1)
  }

  const handleFileChangeImport = (file) => {
    setFileData(file)
  }

  const handleFileUpload = () => {
    if (!fileData) return;
    const formData = new FormData();
    formData.append("file", fileData);
    dispatch(importBulkClient(formData)).then((res) => {
      if (res?.message === "File uploaded successfully! File import started!") {
        message.success("File Uploaded Successfully!")
      } else {
        message.error("Something Went Wrong!")
      }
      handleCloseModal()
    }).catch(() => {
      message.error("Something Went Wrong!")
    })
  }

  return (
    <Modal
      title={t("clients.import_client_list")}
      open={isImportClientModalVisible}
      onCancel={() => handleCloseModal()}
      footer={null}
      width={{ xxl: 626 }}
      height={"500px"}
    >
      <Spin spinning={data?.loading}>
        <div className="mb-m">
          {t("clients.upload_your_list_in_the_format_template_provided")}{" "}
          <a href={`${process.env.REACT_APP_API_URL}/api/v1/guide/clients/download_template`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            {t("clients.download_it_here")}
          </a>
        </div>
        <UploadFile handleFileChangeImport={handleFileChangeImport} setFileData={setFileData} />
        <Flex className="save-wrapper" justify="flex-start" gap={spacings.S} style={{ marginTop: "90px" }}>
          <Button className="pr-xl pl-xl" color="primary" variant="outlined" size="large" onClick={handleCloseModal}>
            {t("global.cancel")}
          </Button>
          <Button
            className="pr-xl pl-xl"
            color="primary"
            variant="solid"
            size="large"
            disabled={!fileData}
            onClick={() => {
              handleFileUpload()
            }}
          >
            {t("clients.import")}
          </Button>
        </Flex>
      </Spin>

    </Modal>
  )
}
export default ImportClientList
